export default __webpack_public_path__ + "static/media/commerce-256x256.22692394.png";